//チャレンジページ
document.addEventListener('DOMContentLoaded', function () {
  if(document.URL.match('challenge')) {
    jQuery('body').addClass('template-challenge');
  }
});  

// おすすめ商品
window.addEventListener("load", function(){
	var item = jQuery('#shopify-section-template--15255310729422__product-recommendations .item').length;
	if (item < 1) {
		jQuery('#shopify-section-template--15255310729422__product-recommendations').css({"display": "none"});
	}
});

